import { render, staticRenderFns } from "./FormSkeleton.vue?vue&type=template&id=5f2e8cb3&scoped=true&"
import script from "./FormSkeleton.vue?vue&type=script&lang=js&"
export * from "./FormSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./FormSkeleton.vue?vue&type=style&index=0&id=5f2e8cb3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2e8cb3",
  null
  
)

export default component.exports